module.exports = __webpack_public_path__ + "startpage-746fed5a/template-4-2x-50b4ae1e9a1812538942af577a9ad05b.jpg";